/* eslint-disable react/jsx-key */
import React, { useState, useEffect, useContext, useRef, useMemo } from 'react'
import * as ScreenPermissions from 'core/EventActions'
import { dateCol, numCol } from '@integec/grid-tools/lib/cols'
import {
  modifierCol,
  modifiedDateCol,
  utilityHeader,
  unitIdHeader,
} from 'core/HeaderColTypeProps'

import { getApiTargetInfo, ExportComponent, UnitSelection } from 'core'
import { connect } from 'react-redux'
import R from 'ramda'
import { gettGenerationHourly, getDateHourList } from 'api/pgads.js'
import {
  getUtilityNameMap,
  getUnitNameMap,
  getUtilityUnitsMap,
  getPermitActions,
  getEnvConfig,
  getValidYearRange,
} from 'core/selectors'
// import ErrorModal from 'core/component/ErrorModal'

import { Button, Input, DatePicker, message, Tabs } from 'antd'
import {
  CriteriaRow,
  Title,
  Content,
  FullHeightSizer,
  Filler,
} from 'core/screen-util'
import Grid, {
  virtualizedGridRenderer,
  freeEditEngine,
} from '@integec/grid-tools'
import {
  rowHeaderRender,
  hasAccesPermits,
  // eslint-disable-next-line no-unused-vars
  exportDataComponent,
  isValidYearRange,
} from 'core/utils'
import moment from 'moment'
import HourlyGenerationDetails from './HourlyGenerationDetails'

import {
  ErrorContext,
  SpinContext,
  DatePickerContext,
  UnitSelectionContext,
} from 'context'

const calcTotalHeader = [
  dateCol({
    ident: 'transdate',
    display: 'Transdate',
    isKey: true,
    width: 200,
  }),
  utilityHeader,
  unitIdHeader,
  numCol({ ident: 'totalGross', display: 'GROSS', isFiltered: true }),
  numCol({ ident: 'totalNet', display: 'NET', isFiltered: true }),
  numCol({ ident: 'totalSS', display: 'SS', isFiltered: true }),
  numCol({ ident: 'totalPump', display: 'PUMP', isFiltered: true }),
  modifierCol,
  modifiedDateCol,
]

const title = 'View Generation'

const HourlyGeneration = ({ apiTargetInfo, ...props }) => {
  const [insertEvent, setInsertEvent] = useState(false)
  const [activeKey, setActiveKey] = useState('data')
  const { setError } = useContext(ErrorContext)
  const { setSpinning } = useContext(SpinContext)
  const { selectedDateRangePicker, setSelectedDateRagePicker } = useContext(
    DatePickerContext
  )
  const { selectedUnits, setVisibleUnitSelection } = useContext(
    UnitSelectionContext
  )

  const { utilityNameMap, unitNameMap } = props

  const [dateHourList, setDateHourList] = useState([])
  useEffect(
    _ => {
      const isValid = isValidYearRange(
        props.validYearRange,
        selectedDateRangePicker[0],
        selectedDateRangePicker[1],
        true
      )
      if (!isValid) return
      getDateHourList(apiTargetInfo)(
        selectedDateRangePicker[0],
        selectedDateRangePicker[1]
      ).fork(setError, setDateHourList)
    },
    [apiTargetInfo, props.validYearRange, selectedDateRangePicker, setError]
  )

  // const utilitysortOpt = (a, b) =>
  //   (utilityNameMap[a] || a).localeCompare(utilityNameMap[b] || b)
  // const unitsortOpt = (a, b) =>
  //   (unitNameMap[a] || '').localeCompare(unitNameMap[b])

  const headerWithFormatter = calcTotalHeader.map(header =>
    header.ident === 'utility'
      ? {
          ...header,
          // ...toSelectionColProps(utilityNameMap),
          dataFormatter: ({ value }) => utilityNameMap[value] || value,
          sortIndexGetter: ({ rowData }) =>
            utilityNameMap[rowData.utility] || rowData.utility,
        }
      : header.ident === 'unitId'
      ? {
          ...header,
          // choices: [],
          // dataGetter: this.generateDataGetter,
          dataFormatter: ({ value }) =>
            value.substr(value.length - 3) === 'ALL'
              ? 'ALL-ALL Units'
              : unitNameMap[value] || value,
          sortIndexGetter: ({ rowData }) =>
            unitNameMap[rowData.unit] || rowData.unit,
        }
      : /*: header.ident === 'effectiveMonth'
        ? {
            ...header,
            choices: mo nthOption,
          } */
        header
  )
  const [fuzzyFilter, setFuzzyFilter] = useState('')
  const GridRef = useRef()
  const GridRemainingRef = useRef()
  const [data, setData] = useState([])
  const [remData, setRemData] = useState([])
  // const [editInfo, setEditInfo] = useState(
  freeEditEngine.generateInitialEditInfo()
  // )

  const [selectedRows, setSelectedRows] = useState([])

  const selectionChange = ({ selectedRows }, ref) => {
    setSelectedRows(selectedRows)
    if (ref.current) {
      // ref.current.setSelectedRect({})
      // selR([])
    }
  }

  const clearData = _ => {
    setData([])
    setRemData([])
    setSelectedRows([])
    setActiveKey('data')
    setInsertEvent(false)
    // setEditInfo(freeEditEngine.generateInitialEditInfo())
  }

  useEffect(clearData, [selectedDateRangePicker])

  const calcTotal = (data, type) => {
    let calc = R.range(1, 25)
      .map(i => parseFloat(data[type + i] || 0))
      .reduce((a, b) => a + b)
    calc = calc + parseFloat(data[type + '2a'] || 0)
    return calc
  }

  const onRetrieveData = _ => {
    if (selectedUnits.length <= 0) {
      message.error('Please,Select Unit(s)')
      setVisibleUnitSelection(true)
      return
    }

    const isValid = isValidYearRange(
      props.validYearRange,
      selectedDateRangePicker[0],
      selectedDateRangePicker[1]
    )
    if (!isValid) return

    setSpinning(true)
    const req = {
      startdate: selectedDateRangePicker[0].format('YYYY-MM-DD'),
      enddate: selectedDateRangePicker[1].format('YYYY-MM-DD'),
      unitid: selectedUnits.map(u => u.unitId),
    }
    gettGenerationHourly(apiTargetInfo)(req).fork(setError, data => {
      setSpinning(false)
      clearData()
      const incTotal = data.map(d => ({
        ...d,
        totalGross: calcTotal(d, 'gross'),
        totalNet: calcTotal(d, 'net'),
        totalSS: calcTotal(d, 'ss'),
        totalPump: calcTotal(d, 'pump'),
      }))
      setData(incTotal)

      const startDate = selectedDateRangePicker[0].clone()
      const endDate = selectedDateRangePicker[1].clone()
      const selectedUnitIds = selectedUnits.map(u => u.unitId)
      const duration = moment.duration(endDate.diff(startDate))
      const days = duration.asDays()
      let remData = R.range(0, days).map(i =>
        selectedUnitIds.map(uid => ({
          isNew: true,
          transdate: startDate
            .clone()
            .add(i, 'days')
            .format('YYYY-MM-DD'),
          unitId: uid,
          utility: uid.substr(0, 3),
          unit: uid.substr(3),
          totalGross: 0,
          totalNet: 0,
          totalSS: 0,
          totalPump: 0,
        }))
      )

      remData = R.flatten(remData)

      remData = remData.filter(
        r =>
          !incTotal.find(
            d => d.transdate === r.transdate && r.unitId === d.unitId
          )
      )

      setRemData(remData)
    })
  }

  const adminPermission = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: props.envConfig.authGodMode,
        actionPermits: props.actionPermits,
        eventActions: [ScreenPermissions.ADMIN_GENERATION_BY_HOUR],
        matchAny: true,
      }),
    [props.actionPermits, props.envConfig.authGodMode]
  )

  const getTypeDetailData = (data, type) =>
    R.range(1, 25).map(i => ({ ['hr' + i]: data[type + i] || 0 }))

  const getDetailData = data => {
    if (data === undefined) return undefined
    const { transdate, unit, utility, unitId, isNew = false } = data

    let grossRow = getTypeDetailData(data, 'gross')

    grossRow = R.reduce(
      (a, b) => ({ ...a, ...b }),
      {
        isNew,
        prefix: 'gross',
        display: 'GROSS',
        hr2a: data.gross2a || 0,
        transdate,
        unit,
        utility,
        unitId,
      },
      grossRow
    )

    let netRow = getTypeDetailData(data, 'net')
    netRow = R.reduce(
      (a, b) => ({ ...a, ...b }),
      {
        isNew,
        prefix: 'net',
        display: 'NET',
        hr2a: data.net2a || 0,
        transdate,
        unit,
        utility,
        unitId,
      },
      netRow
    )

    let ssRow = getTypeDetailData(data, 'ss')
    ssRow = R.reduce(
      (a, b) => ({ ...a, ...b }),
      {
        isNew,
        prefix: 'ss',
        display: 'SS',
        hr2a: data.ss2a || 0,
        transdate,
        unit,
        utility,
        unitId,
      },
      ssRow
    )

    let pumpRow = getTypeDetailData(data, 'pump')
    pumpRow = R.reduce(
      (a, b) => ({ ...a, ...b }),
      {
        isNew,
        prefix: 'pump',
        display: 'PUMP',
        hr2a: data.pump2a || 0,
        transdate,
        unit,
        utility,
        unitId,
      },
      pumpRow
    )

    return [grossRow, netRow, ssRow, pumpRow]
  }

  return (
    <div>
      <UnitSelection />
      <CriteriaRow style={{}}>
        <Title
          style={{
            marginRight: '15px',
            marginBottom: '5px',
            marginLeft: '10px',
            minWidth: '100px',
          }}
        >
          {title}
        </Title>
        <DatePicker.RangePicker
          style={{ marginLeft: '15px' }}
          allowClear={false}
          format="MM/DD/YYYY"
          value={selectedDateRangePicker}
          onChange={d => {
            setSelectedDateRagePicker(d)
            clearData()
            // retrieve({ dates: d })
          }}
        />

        <Button
          style={{ marginLeft: '10px' }}
          onClick={onRetrieveData}
          type="primary"
          icon="database"
        >
          Retrieve
        </Button>

        {adminPermission && (
          <Button
            style={{ marginLeft: '10px' }}
            onClick={_ => setInsertEvent(!insertEvent)}
            disabled={selectedRows.length <= 0}
          >
            {!insertEvent ? 'View Details Data' : 'Hide Details Data'}
          </Button>
        )}

        <Filler />
        <Input.Search
          placeholder="Filter"
          value={fuzzyFilter}
          style={{
            marginLeft: '10px',
            marginRight: '10px',
            flex: '0 0 200px',
          }}
          onChange={e => setFuzzyFilter(e.target.value)}
        />
        <ExportComponent
          data={data}
          headers={(headerWithFormatter || []).map(d => ({
            ...d,
            rowHeaderBackgroundColor: '#eee',
          }))}
          fileName={title}
          btnStyle={{ marginRight: '10px' }}
          disabled={data.length <= 0}
        />
        {/* <ExportComponent
                    getData={_ =>
                      exportDataComponent(this.GridRef, data, fuzzyFilter)
                    }
                    data={data}
                    headers={(header || []).map(d => ({
                      ...d,
                      rowHeaderBackgroundColor: '#eee',
                    }))}
                    fileName={this.props.title}
                    btnStyle={{ marginRight: '10px' }}
                    disabled={data.length <= 0}
                  /> */}
      </CriteriaRow>
      {adminPermission && insertEvent && selectedRows.length >= 1 && (
        <Content
          style={{ padding: '5px', marginTop: '5px', maxHeight: '180px' }}
        >
          <FullHeightSizer>
            {({ width }) => (
              <HourlyGenerationDetails
                data={getDetailData(selectedRows[0])}
                apitargetInfo={apiTargetInfo}
                onRetrieveData={onRetrieveData}
                utilityNameMap={utilityNameMap}
                unitNameMap={unitNameMap}
                setInsertEvent={setInsertEvent}
                dateHourList={dateHourList}
                width={width - 50}
              />
            )}
          </FullHeightSizer>
        </Content>
      )}
      <FullHeightSizer heightOffset={insertEvent ? 320 : 230}>
        {({ height, width }) => (
          <Content style={{ height: height - 20 }}>
            <Tabs
              style={{ height: height - 10, width }}
              activeKey={activeKey}
              onChange={setActiveKey}
            >
              <Tabs.TabPane tab="Data" key="data">
                <Grid
                  ref={GridRef}
                  sortEnabled
                  data={data}
                  headers={headerWithFormatter}
                  altBy={u => u.unitId}
                  altBgColor="#ebebeb"
                  // onEditInfoChange={info => editRow(info)}
                  // editInfo={editInfo}
                  render={virtualizedGridRenderer({
                    headerRowHeight: 30,
                    autoFixColByKey: false,
                    rowHeaderRender,
                    height: height - 100,
                    width: width - 50,
                    // cellRender: customizedCellRender,
                  })}
                  fuzzyFilter={fuzzyFilter}
                  isEditable={false}
                  onSelectionChange={rows => {
                    selectionChange(rows, GridRemainingRef)
                  }}
                  selectionMode="single"
                  selectionType="row"
                  initialSortOptions={[
                    unitIdHeader,
                    dateCol({
                      ident: 'transdate',
                      display: 'Transdate',
                      isKey: true,
                      width: 200,
                      sortOrder: 'asc',
                    }),
                  ]}
                />
              </Tabs.TabPane>
              <Tabs.TabPane tab="Remaining Data" key="remdata">
                <Grid
                  ref={GridRemainingRef}
                  sortEnabled
                  data={remData}
                  headers={headerWithFormatter}
                  altBy={u => u.unitId}
                  altBgColor="#ebebeb"
                  // onEditInfoChange={info => editRow(info)}
                  // editInfo={editInfo}
                  render={virtualizedGridRenderer({
                    headerRowHeight: 30,
                    autoFixColByKey: false,
                    rowHeaderRender,
                    height: height - 100,
                    width: width - 50,
                    // cellRender: customizedCellRender,
                  })}
                  fuzzyFilter={fuzzyFilter}
                  isEditable={false}
                  onSelectionChange={rows => {
                    selectionChange(rows, GridRef)
                  }}
                  selectionMode="single"
                  selectionType="row"
                  initialSortOptions={[
                    unitIdHeader,
                    dateCol({
                      ident: 'transdate',
                      display: 'Transdate',
                      sortOrder: 'asc',
                    }),
                  ]}
                />
              </Tabs.TabPane>
            </Tabs>
          </Content>
        )}
      </FullHeightSizer>
    </div>
  )
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
  utilityNameMap: getUtilityNameMap(state),
  unitNameMap: getUnitNameMap(state),
  utilityUnitMap: getUtilityUnitsMap(state),
  actionPermits: getPermitActions(state),
  envConfig: getEnvConfig(state),
  validYearRange: getValidYearRange(state),
})

export default connect(mapStateToProps)(HourlyGeneration)
